import type { ComponentPropsWithRef } from "react";

import { cn } from "@intergamma/common/cn";

export function Return({ className, ...props }: ComponentPropsWithRef<"svg">) {
  return (
    <>
      <svg
        className={cn("karwei:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20.2501 5.5C20.2501 5.08579 19.9143 4.75 19.5001 4.75C19.0859 4.75 18.7501 5.08579 18.7501 5.5V10C18.7501 11.7949 17.295 13.25 15.5001 13.25H6.31077L10.0304 9.53033C10.3233 9.23744 10.3233 8.76256 10.0304 8.46967C9.73755 8.17678 9.26268 8.17678 8.96978 8.46967L3.43945 14L8.96978 19.5303C9.26268 19.8232 9.73755 19.8232 10.0304 19.5303C10.3233 19.2374 10.3233 18.7626 10.0304 18.4697L6.31077 14.75H15.5001C18.1235 14.75 20.2501 12.6234 20.2501 10V5.5Z"
          fill="currentColor"
        />
      </svg>
      <svg
        className={cn("gamma:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 4.5V10.7188C20 12.6517 18.433 14.2188 16.5 14.2188H5.45712L8.99419 17.7558L8.28709 18.4629L3.54291 13.7188L8.28709 8.97457L8.99419 9.68168L5.45712 13.2188H16.5C17.8807 13.2188 19 12.0995 19 10.7188V4.5H20Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
